export default "__VITE_ASSET__CwTbOE$Y__"